// frontend/src/pages/ForgotPasswordPage.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Mail, CheckCircle } from 'lucide-react';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await axios.post('/api/auth/forgot-password', { email });
      setSubmitted(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-light flex items-center justify-center">
      <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-md">

        <button
          onClick={() => navigate('/login')}
          className="inline-flex items-center gap-1.5 text-sm text-gray-400 hover:text-brand-dark transition-colors mb-6"
        >
          <ArrowLeft size={15} />
          Back to login
        </button>

        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-brand-dark">Reset Password</h1>
          <p className="text-gray-500 mt-2 text-sm">
            Enter your email and we'll send you a reset link.
          </p>
        </div>

        {submitted ? (
          <div className="text-center py-4">
            <CheckCircle className="mx-auto text-green-500 mb-4" size={48} />
            <p className="text-gray-700 font-medium">Check your inbox</p>
            <p className="text-gray-500 text-sm mt-2">
              If an account exists for <strong>{email}</strong>, a reset link has been sent. It expires in 1 hour.
            </p>
            <button
              onClick={() => navigate('/login')}
              className="mt-6 w-full bg-brand-dark text-white py-2 px-4 rounded-lg hover:bg-brand-mid transition-colors text-sm"
            >
              Back to Login
            </button>
          </div>
        ) : (
          <>
            {error && (
              <div className="bg-red-50 text-red-600 p-3 rounded-lg mb-4 text-sm">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <div className="relative">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-4 py-2 pl-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-mid focus:border-transparent"
                    placeholder="Enter your email"
                    required
                  />
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-brand-dark text-white py-2 px-4 rounded-lg hover:bg-brand-mid transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          </>
        )}

        <p className="text-center text-xs text-gray-400 mt-6">
          RN Consulting & Associates Ltd © 2026
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
